import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, ViewChildren, QueryList, HostListener, NgZone, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../services/common.service';
import { WaitpromiseService } from '../services/waitpromise.service';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { ViewportRuler, ScrollDispatcher } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-autocomplete-material',
  templateUrl: './autocomplete-material.component.html',
  styleUrls: ['./autocomplete-material.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // ← Optimisation majeure
})
export class AutocompleteMaterialComponent implements OnInit, OnChanges, OnDestroy {
  // Inputs
  @Input() autocompleteMaterial: Boolean;
  @Input() placeholder: String = '';
  @Input() dataSource: any[];
  @Input() results: any[];
  @Input() label: string;
  @Input() defaultsearch: String = '';
  @Input() id: String;
  @Input() notOblig: boolean;
  @Input() active: boolean;
  @Input() minlength: number = 1;
  @Input() maxlength: number;
  @Input() autoshow: boolean;
  @Input() autohide: boolean;
  @Input() selectvalue: boolean;
  @Input() disablefocus: boolean;
  @Input() isCombo: boolean;
  @Input() container;
  @Input() model;
  @Input() items;
  @Input() defaultselected;
  @Input() dropdownclass: String;
  @Input() highlight: boolean;
  @Input() showonclick: boolean;
  @Input() showonFoscus: boolean;
  @Input() showResultKeyenter: boolean;
  @Input() deleteSelectedValue: boolean;
  @Input() rechercheIcone: boolean;
  @Input() isFixedHTML: boolean;
  @Input() htmlCode;
  @Input() forceSelection: boolean = true;
  @Input() activeDropUp: boolean;
  @Input() activeVisibleChamp: boolean = false;
  @Input() visibleChamp: boolean = true;
  @Input() notLoading: boolean;
  @Input() isDisabled: Boolean = false;
  @Input() addTimerBlur: Boolean = false;
  @Input() deleteLibelle: Boolean = false;
  @Input() showArrowDown: Boolean = false;
  @Input() showLabel: Boolean = false;
  @Input() changeIDAutoComplete: Boolean = false;
  @Input() material: Boolean = false;
  @Input() positionDropdown = 'left';
  @Input() isFormatComptaDate;
  @Input() nepasGarderValeur: Boolean = false;
  @Input() pastoogledebut: Boolean = false;
  @Input() encoursDechargement: Boolean = false;
  @Input() reload;
  @Input() autoActiveFirstOption: Boolean = true;
  @Input() notShowOnInit: Boolean = false;
  @Input() ActiveFocusCombo: Boolean = false;
  @Input() actualise: Boolean = false;
  @Input() isKeyUp: Boolean = false;
  @Input() isClearResult: Boolean = false;
  @Input() activeDelaiRecherche: Boolean = false;
  @Input() nePasCompterEspace: Boolean = false;
  @Input() maxResults: number = 100; // ← Nouveau: limiter les résultats

  // Outputs
  @Output() searchfunction = new EventEmitter<String>();
  @Output() selectfunction = new EventEmitter<String>();
  @Output() keyenterfunction = new EventEmitter<String>();
  @Output() focusfunction = new EventEmitter<any>();
  @Output() blurfunction = new EventEmitter<any>();
  @Output() clearfunction = new EventEmitter<any>();
  @Output() keyUp = new EventEmitter<any>();

  // State variables
  status: { isopen: boolean } = { isopen: false };
  plhd: String = '';
  isFocus: Boolean = false;
  search: string = '';
  isValueSel: Boolean = false;
  selected: any = {};
  delay: any;
  isChargement: boolean;
  dropup: Boolean = false;
  dejaActifApresChoix: Boolean = false;
  idElement: string = '';
  searchExec: string = '';
  hasRequestLoad: Boolean = false;
  numeroAutoComplete: number = 0;
  lastKey: string | null = null;

  private lastSelectionTime: number = 0;
  private readonly SELECTION_BLUR_THRESHOLD = 200; // ms

  // Optimisation: Cache pour les textes d'affichage
  private displayTextCache = new Map<string, string>();
  private subscriptions: Subscription = new Subscription();
  private searchSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private scrollListener: () => void;

  // ViewChildren
  @ViewChild('autocompletematerial') autocompletematerial: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
  @ViewChild('inputCombo') inputCombo: ElementRef;
  @ViewChildren(MatOption) matOptions!: QueryList<MatOption>;

  constructor(
    protected common: CommonService,
    public waitProm: WaitpromiseService,
    private scrollDispatcher: ScrollDispatcher,
    private viewportRuler: ViewportRuler,
    private ngZone: NgZone,
    private cdRef: ChangeDetectorRef // ← Pour ChangeDetectionStrategy.OnPush
  ) {
    this.initializeComponent();
  }

  private initializeComponent(): void {
    this.numeroAutoComplete = this.common.indexAutoComplete++;
    this.setupSearchDebounce();
    this.setupWaitPromSubscription();
    this.setupGlobalScrollListener();
  }

  private setupSearchDebounce(): void {
    let debounceTimeMs = 500;
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe["clientCollectivite"] && this.activeDelaiRecherche) {
      const userDetail = this.common.local.getObject('userDetail');
      debounceTimeMs = userDetail['delaiRecherche'] || 500;
    }

    this.subscriptions.add(
      this.searchSubject.pipe(
        debounceTime(debounceTimeMs),
        distinctUntilChanged(),
        filter(search => this.shouldSearch(search))
      ).subscribe(searchTerm => {
        console.log(searchTerm)
        this.handleSearch(searchTerm);
      })
    );
  }

  private shouldSearch(searchTerm: string): boolean {
    const searchLength = this.nePasCompterEspace ?
      searchTerm.replace(/\s+/g, '').length : searchTerm.length;
    return searchLength >= this.minlength || this.autoshow;
  }

  private setupWaitPromSubscription(): void {
    this.waitProm.doSomething[this.numeroAutoComplete] = new BehaviorSubject<any>(null);

    this.subscriptions.add(
      this.waitProm.doSomething[this.numeroAutoComplete].subscribe(data => {
        if (data) {
          this.handleWaitPromComplete();
        }
      })
    );
  }

  private setupGlobalScrollListener(): void {
    this.scrollListener = this.ngZone.runOutsideAngular(() => {
      const handler = (event: Event) => {
        if (event.target instanceof Element) {
          const isPanelOrChild = event.target.closest('.mat-autocomplete-panel') ||
            event.target.closest('.cdk-overlay-pane');
          if (!isPanelOrChild && this.autocompleteTrigger?.panelOpen) {
            this.ngZone.run(() => {
              this.autocompleteTrigger.closePanel();
            });
          }
        }
      };

      document.addEventListener('scroll', handler, { capture: true, passive: true });
      return () => document.removeEventListener('scroll', handler, { capture: true });
    });
  }

  ngOnInit() {
    this.initializeProperties();
    this.setupInitialFocus();
    this.selected = this.defaultselected ? this.defaultselected : this.selected;
    this.handleAutoShow();
    this.handleComboCase();
  }

  private initializeProperties(): void {
    this.search = String(this.defaultsearch || '');
    this.plhd = this.placeholder || '';
    this.selected = this.getInitialSelected();
    this.minlength = this.minlength || 1;
    this.forceSelection = this.forceSelection !== false;
    this.isChargement = !this.notLoading;

    this.idElement = 'autocomplete' + Math.random().toString(36).slice(-6);
  }

  private getInitialSelected(): any {
    if (this.search.length) {
      return this.defaultselected || (this.results?.length ? this.results[0] : {});
    }
    return {};
  }

  private setupInitialFocus(): void {
    const url = window.location.href || '';
    if (url.includes('/param/menu-article/article') || this.disablefocus || this.selectvalue || this.common.isFiche) {
      return;
    }

    setTimeout(() => {
      if (this.ActiveFocusCombo && this.isCombo) {
        this.triggerComboClick();
      } else if (!this.autoshow) {
        this.focusInput();
      }
    }, 500);
  }

  private triggerComboClick(): void {
    const element = document.querySelector('.' + this.id);
    if (element) (element as HTMLElement).click();
  }

  private focusInput(): void {
    const selector = this.changeIDAutoComplete ? '#' + this.idElement : '#autocomplete';
    const inputElement = document.querySelector(selector) as HTMLElement;
    if (inputElement) inputElement.focus();
  }

  private handleAutoShow(): void {
    if (this.autoshow && !this.status.isopen && !this.notShowOnInit) {
      this.toggleDropdown();
    }
    if (this.autoshow && !this.hasRequestLoad) {
      this.initiateSearch();
    }
  }

  private handleComboCase(): void {
    if (this.isCombo && !this.hasRequestLoad) {
      this.initiateSearch();
      this.isChargement = false;
      this.selected = this.selected || (this.results?.length ? this.results[0] : {});
    }
  }

  ngOnChanges(changes: any) {
    if (changes.defaultsearch) {
      this.search = String(changes.defaultsearch.currentValue);
    }

    if (changes.encoursDechargement) {
      this.encoursDechargement = !!changes.encoursDechargement.currentValue;
    }

    if (changes.defaultselected) {
      this.selected = this.defaultselected || this.selected;
      this.selected = this.selected || (this.results?.length ? this.results[0] : {});
    }

    this.syncFromIdRequeteEncours();

    this.checkRequestStatus();

    if (changes.results) {
      this.handleResultsChange();
    }
  }

  private checkRequestStatus(): void {
    const IdRequeteEncours = Number(this.common.local.get('IdRequeteEncours'));
    if (!IdRequeteEncours || IdRequeteEncours !== this.numeroAutoComplete) {
      this.hasRequestLoad = false;
      this.isChargement = false;
      this.common.local.remove('numautocomplete');
      this.common.local.remove('IdRequeteEncours');
    }
  }

  private handleResultsChange(): void {
    this.isChargement = false;
    // Limiter les résultats pour la performance
    // if (this.results && this.results.length > this.maxResults) {
    //   this.results = this.results.slice(0, this.maxResults);
    // }
    this.results = this.results;
    this.markForCheck();
    if (this.selected && this.selected.id) {
      this.highlightSelectedOption(100)
    }

    if (this.hasRequestLoad) this.syncFromIdRequeteEncours();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.scrollListener) {
      this.scrollListener();
    }
    if (this.delay) {
      clearTimeout(this.delay);
    }
  }

  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent): void {
  //   if (this.inputCombo?.nativeElement) {
  //     const clickedInsideInput = this.inputCombo.nativeElement.contains(event.target);
  //     const clickedInsidePanel = this.autocompleteTrigger?.autocomplete?.panel?.nativeElement.contains(event.target);

  //     if (!clickedInsideInput && !clickedInsidePanel) {
  //       this.autocompleteTrigger.closePanel();
  //     }
  //   }
  // }

  @HostListener('document:mousedown', ['$event'])
  onDocumentMouseDown(event: MouseEvent): void {
    const target = event.target as Element | null;
    if (!target) return;

    const clickedInsideInput = this.inputCombo?.nativeElement?.contains(target);
    // Tout ce qui est dans l’overlay du panel (y compris mat-option)
    const clickedInsideOverlay = !!target.closest('.cdk-overlay-pane');

    if (clickedInsideInput || clickedInsideOverlay) {
      return; // ne ferme pas
    }

    // Ferme "proprement" après la propagation des events en cours
    queueMicrotask(() => this.autocompleteTrigger?.closePanel());
  }

  // Méthodes publiques
  showAutoCompleteMaterial(): void {
    if (this.autocompletematerial) {
      this.autocompletematerial.nativeElement.focus();
    }
  }

  onSearchInput(event: any): void {
    if (event && event.target) {
      this.searchSubject.next(event.target.value);
    } else {
      if (typeof event !== 'string') {
        setTimeout(() => this.selectItem(event), 10);
        return;
      } else {
        this.searchSubject.next(event);
      }
    }
  }



  searchelement(event: any): void {
    if (typeof event !== 'string') {
      setTimeout(() => this.selectItem(event), 10);
      return;
    }

    const searchLength = this.nePasCompterEspace ?
      event.replace(/\s+/g, '').length : event.length;

    if (!searchLength || event === '' || this.isValueSel) {
      this.clearfunction.emit();
      this.isValueSel = false;
    }

    if (this.items && this.model) {
      this.items[this.model] = event;
    }

    if (searchLength >= this.minlength || this.autoshow) {
      this.prepareForSearch();
    }

    if (this.deleteSelectedValue && searchLength === 0) {
      this.selectfunction.emit();
    }

    if (searchLength < this.minlength && !this.autoshow) {
      this.closeAutocomplete();
    }
  }

  private syncFromIdRequeteEncours(): void {
    const idReq = Number(this.common.local.get('IdRequeteEncours'));
    if (!idReq) {
      // Rien en cours globalement -> stoppe le loader local
      this.hasRequestLoad = false;
      this.isChargement = false;
      this.markForCheck();
    }
  }

  private prepareForSearch(): void {
    this.isChargement = true;
    this.markForCheck();

    if (!this.status.isopen) {
      this.toggleDropdown();
    }

    if (!this.hasRequestLoad) {
      this.initiateSearch();
    }
  }

  private initiateSearch(): void {
    this.hasRequestLoad = true;
    this.common.local.set('numautocomplete', '' + this.numeroAutoComplete);
    this.searchExec = this.search;
    this.searchfunction.emit(this.search);

    // 🔎 Laisse une micro-tâche à base.ts pour poser la clé, puis on se resynchronise
    queueMicrotask(() => this.syncFromIdRequeteEncours());

    // ⏱️ filet de sécurité si base.ts est asynchrone
    setTimeout(() => this.syncFromIdRequeteEncours(), 60);
  }

  private closeAutocomplete(): void {
    this.status.isopen = false;
    this.results = [];
    this.autocompleteTrigger?.closePanel();
    this.markForCheck();
  }

  clickCombo(): void {
    this.focusfunction.emit();
  }

  clickfct(): void {
    if (this.showonclick || this.autoshow || (this.autoActiveFirstOption && this.showonFoscus)) {
      this.autocompleteTrigger.closePanel();
      this.isFocus = true;
      this.focusfunction.emit();
      setTimeout(() => this.focusfct(), 50);
    }
  }

  focus(): void {
    if (!this.autoActiveFirstOption) {
      this.isFocus = true;
      if (this.showonFoscus) {
        this.dejaActifApresChoix = false;
        this.focusfct();
      }
    } else if (!this.showonclick && !this.autoshow && !this.showonFoscus) {
      this.autocompleteTrigger.closePanel();
      this.isFocus = true;
      this.focusfunction.emit();
      setTimeout(() => this.focusfct(), 50);
    }
  }

  focusfct(): void {
    if (this.autoshow && !this.status.isopen) {
      this.toggleDropdown();
    }

    if (!this.isCombo && this.selectvalue) {
      this.isValueSel = true;
      const activeElement = document.activeElement;

      // Vérification plus robuste avant d'appeler select()
      if (activeElement &&
        (activeElement instanceof HTMLInputElement ||
          activeElement instanceof HTMLTextAreaElement)) {
        activeElement.select();
      } else if (activeElement) {
        console.warn('Active element is not selectable:', activeElement);
      }
    }

    if (this.isCombo) {
      this.isChargement = false;
    } else {
      this.handleNonComboFocus();
    }
  }

  private handleNonComboFocus(): void {
    if (this.showonclick) {
      this.handleShowOnClick();
    } else if (this.showonFoscus) {
      this.handleShowOnFocus();
    }
  }

  private handleShowOnClick(): void {
    if (!this.status.isopen) {
      this.toggleDropdown();
    }
    if (!this.hasRequestLoad) {
      this.initiateSearchWithLoading();
    }
  }

  private handleShowOnFocus(): void {
    if (!this.status.isopen) {
      this.toggleDropdown();
    }
    if (!this.hasRequestLoad) {
      this.hasRequestLoad = true;
      this.isChargement = true;
      this.common.local.set('numautocomplete', '' + this.numeroAutoComplete);
      this.searchfunction.emit('');

      // 🔎 Laisse une micro-tâche à base.ts pour poser la clé, puis on se resynchronise
      queueMicrotask(() => this.syncFromIdRequeteEncours());

      // ⏱️ filet de sécurité si base.ts est asynchrone
      setTimeout(() => this.syncFromIdRequeteEncours(), 60);
    }
  }

  private initiateSearchWithLoading(): void {
    this.hasRequestLoad = true;
    this.isChargement = true;
    this.common.local.set('numautocomplete', '' + this.numeroAutoComplete);
    console.log('initiateSearchWithLoading', this.search)
    if (this.selected && this.selected.id && typeof this.search === 'object') {
      const displayText = this.getDisplayTextForItem(this.selected);
      this.search = displayText;
    }


    this.searchfunction.emit(this.search);

    // 🔎 Laisse une micro-tâche à base.ts pour poser la clé, puis on se resynchronise
    queueMicrotask(() => this.syncFromIdRequeteEncours());

    // ⏱️ filet de sécurité si base.ts est asynchrone
    setTimeout(() => this.syncFromIdRequeteEncours(), 60);
  }

  blurfct(): void {
    // Vérifier si le blur arrive juste après une sélection
    const timeSinceSelection = Date.now() - this.lastSelectionTime;
    if (timeSinceSelection < this.SELECTION_BLUR_THRESHOLD) {
      return; // ← Ignorer le blur post-sélection
    }

    if (!this.autocompleteTrigger?.panelOpen) {
      const time = setTimeout(() => {
        clearTimeout(time);
        this.blurfunction.emit();
      }, this.addTimerBlur ? 50 : 0);
    }
  }

  toggleDropdown(): void {
    if (!this.autocompleteTrigger) return;

    this.status.isopen = !this.status.isopen;
    if (this.status.isopen) {
      this.autocompleteTrigger.openPanel();
      this.inputCombo.nativeElement.focus();
      if (this.matAutocomplete?.options) {
        this.matAutocomplete.options.forEach((option, index) => {
          if (option.value && this.selected && option.value.id === this.selected.id) {
            option.select();
          }
        });
      }
      this.highlightSelectedOption();
    } else {
      this.autocompleteTrigger.closePanel();
    }
  }

  private highlightSelectedOption(timeout?): void {
    setTimeout(() => {
      if (this.matAutocomplete?.options) {
        const optionsArray = this.matAutocomplete.options.toArray();
        const selectedIndex = optionsArray
          .findIndex(option => option.value && this.selected && option.value.id === this.selected.id);

        if (selectedIndex >= 0) {
          const activeOption = optionsArray[selectedIndex];

          // Met en surbrillance et sélectionne l'option
          this.matAutocomplete._keyManager.setActiveItem(selectedIndex);

          // Scroll pour rendre l'option visible
          activeOption._getHostElement().scrollIntoView({ block: 'nearest' });
        }
      }
    }, timeout || 0);
  }

  selectItem(item?: any): void {
    this.lastSelectionTime = Date.now();
    if (!item) return;

    this.dejaActifApresChoix = true;
    const displayText = this.getDisplayTextForItem(item);

    if (this.forceSelection) {
      this.selected = item;
      this.search = displayText;
    } else {
      this.handleNonForcedSelection(item, displayText);
    }

    this.finalizeSelection();
  }

  private getDisplayTextForItem(item: any): string {
    const libelleCht = item.numChantier ?
      `${item.numChantier} / ${item.responsable || ''} / ${item.ville} / ${item.telephone || ''}` : '';
    return item.libelleObjetEntite || libelleCht || '';
  }

  private handleNonForcedSelection(item: any, displayText: string): void {
    if (!this.selected || this.selected.id !== item.id) {
      this.selected = item;
      this.search = this.autohide ? displayText : '';
    } else {
      this.selected = item;
      this.search = displayText;
    }
  }

  private finalizeSelection(): void {
    this.status.isopen = false;

    if (this.deleteLibelle) {
      this.search = '';
      if (this.showArrowDown) {
        this.triggerArrowDownClick();
      }
      if (this.inputCombo && !this.showArrowDown) {
        this.inputCombo.nativeElement.value = '';
      }
    }

    this.blurInput();
    this.selectfunction.emit(this.selected);

    if (this.actualise) {
      setTimeout(() => {
        this.search = String(this.defaultsearch || '');
      }, 300);
    }

    this.markForCheck();
  }

  private triggerArrowDownClick(): void {
    const arrowDown = document.querySelector('.arrowDownMat') as HTMLElement;
    if (arrowDown) arrowDown.click();
  }

  private blurInput(): void {
    if (this.inputCombo) {
      this.inputCombo.nativeElement.blur();
    }
  }

  valideChoice(item: any): void {
    if (this.search === '' && this.showResultKeyenter && !this.hasRequestLoad) {
      this.prepareForSearch();
    }

    if (this.results?.length === 1) {
      this.selectItem(this.results[0]);
    }

    this.keyenterfunction.emit(item);
  }

  getOptionText(item: any): string {
    if (this.showArrowDown) return this.placeholder.toString();

    if (typeof item === 'string') return item;

    if (item) {
      const libelleCht = item.numChantier ?
        `${item.numChantier} / ${item.responsable || ''} / ${item.ville} / ${item.telephone || ''}` : '';
      return item.libelleObjetEntite || libelleCht || '';
    } else {
      return ''
    }

  }

  // Optimisation: Mémoization pour getOptionText
  private getCachedOptionText(item: any): string {
    const cacheKey = item.id ? `id_${item.id}` : JSON.stringify(item);
    if (this.displayTextCache.has(cacheKey)) {
      return this.displayTextCache.get(cacheKey);
    }

    const text = this.getOptionText(item);
    this.displayTextCache.set(cacheKey, text);
    return text;
  }

  defaultFocus(event: any): void {
    if (event) {
      this.keyUp.emit(this.isKeyUp ? event : this.search);
    }
  }

  keydown(event: KeyboardEvent): void {
    this.lastKey = event.key;
  }

  onAutocompleteOpened(): void {
    const selectedIndex = this.results?.findIndex(o => o && this.selected && o.id === this.selected.id) ?? -1;
    if (selectedIndex >= 0) {
      setTimeout(() => {
        if (this.matAutocomplete?._keyManager) {
          this.matAutocomplete._keyManager.setActiveItem(selectedIndex);
        }
      });
    }
  }

  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();

    setTimeout(() => {
      if (this.isPanelOpen()) {
        this.selectOptionOnEnter();
      } else {
        this.valideChoice(event);
      }
    }, 10);
  }

  private isPanelOpen(): boolean {
    return !!(
      this.autocompleteTrigger?.panelOpen ||
      this.status.isopen ||
      document.querySelector('.mat-autocomplete-panel:not([aria-hidden="true"])') ||
      document.querySelector('.cdk-overlay-pane.mat-autocomplete-panel')
    );
  }

  private selectOptionOnEnter(): void {
    let activeOption = this.findActiveOption();

    if (!activeOption && this.results?.length === 1) {
      activeOption = this.results[0];
    }

    if (activeOption) {
      this.selectItem(activeOption);
    } else {
      this.autocompleteTrigger?.closePanel();
      this.status.isopen = false;
      this.keyenterfunction.emit(this.search);
    }
  }

  private findActiveOption(): any {
    // Méthode 1: KeyboardManager
    if (this.matAutocomplete?._keyManager?.activeItem) {
      return this.matAutocomplete._keyManager.activeItem.value;
    }

    // Méthode 2: Options actives
    if (this.matAutocomplete?.options) {
      const activeMatOption = this.matAutocomplete.options.find(opt => opt.active);
      if (activeMatOption) {
        return activeMatOption.value;
      }
    }

    return null;
  }

  private handleWaitPromComplete(): void {
    this.hasRequestLoad = false;
    this.isChargement = false;
    this.common.local.remove('numautocomplete');
    this.common.local.remove('IdRequeteEncours');
    this.markForCheck();
  }

  private handleSearch(searchTerm: string): void {
    this.searchelement(searchTerm);
  }

  private markForCheck(): void {
    this.cdRef.markForCheck();
  }

  // Méthode trackBy optimisée
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  // Méthode pour obtenir le contenu d'affichage avec cache
  getItemDisplayContent(item: any): string {
    if (!item) return '';

    // Utiliser le cache pour les performances
    const cacheKey = item.id ? `display_${item.id}` : JSON.stringify(item);
    if (this.displayTextCache.has(cacheKey)) {
      return this.displayTextCache.get(cacheKey);
    }

    let content: string;

    if (item.libelleObjetEntite) {
      content = item.libelleObjetEntite;
    } else {
      // Construction optimisée du libellé chantier
      const parts = [
        item.numChantier,
        item.responsable,
        item.adresse1,
        item.ville,
        item.telephone
      ].filter(part => part && part.trim() !== '');

      content = parts.join(' / ');
    }

    // Mettre en cache
    this.displayTextCache.set(cacheKey, content);
    return content;
  }

  // Méthode pour vider le cache si nécessaire
  clearDisplayCache(): void {
    this.displayTextCache.clear();
  }
}